import { ReactNode, useState, useCallback } from 'react';
import { m } from 'framer-motion';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from '../ScrollToTop';
import { AboutOverlay } from '../AboutOverlay';

interface LayoutProps {
  children: ReactNode;
  showFooter?: boolean;
}

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  enter: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.25, ease: [0.25, 0.1, 0.25, 1] as const },
  },
  exit: {
    opacity: 0,
    y: -8,
    transition: { duration: 0.25, ease: [0.25, 0.1, 0.25, 1] as const },
  },
};

export function Layout({ children, showFooter = true }: LayoutProps) {
  const [isAboutOpen, setIsAboutOpen] = useState(false);

  const handleAboutOpen = useCallback(() => setIsAboutOpen(true), []);
  const handleAboutClose = useCallback(() => setIsAboutOpen(false), []);

  return (
    <div className="min-h-screen bg-black flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-white focus:text-black focus:font-en focus:font-bold focus:text-sm focus:uppercase focus:tracking-widest"
      >
        Skip to content
      </a>
      <Header onAboutClick={handleAboutOpen} />
      <m.main
        id="main-content"
        variants={pageVariants}
        initial="initial"
        animate="enter"
        exit="exit"
        className="flex-1 pt-16 md:pt-20"
      >
        {children}
      </m.main>
      {showFooter && <Footer />}
      <ScrollToTop />
      <AboutOverlay isOpen={isAboutOpen} onClose={handleAboutClose} />
    </div>
  );
}
